<template>
  <div class="industrialPark">
    <!-- 查询和新增操作 -->
    <el-form :inline="true" :model="queryInfo">
      <div class="search-form">
        <div class="bottom-box">
          <div class="item-condition">
            <el-form-item label="	产业园区名称:">
              <el-input
                placeholder="请输入名称"
                v-model="queryInfo.industrialName"
                clearable
              ></el-input>
            </el-form-item>
          </div>
          <div class="item-condition">
            <el-form-item label="年度:">
              <el-input
                placeholder="请输入xx年,xx年"
                v-model="queryInfo.annual"
                clearable
              ></el-input>
            </el-form-item>
          </div>
          <div class="item-condition">
            <el-form-item>
              <el-button type="primary" @click="getIndustrialParkList(1)">
                查询
              </el-button>
              <el-button @click="addOrUpdateHandle()">新增</el-button>
              <el-button type="warning" @click="chongzhi"> 重置 </el-button>
            </el-form-item>
          </div>
        </div>
        <div class="top-box">
          <div class="item-condition">
            <el-form-item label="审核状态:" class="item-short">
              <el-select
                v-model="queryInfo.checkStatus"
                placeholder="请选择状态"
                clearable
              >
                <el-option
                  v-for="item in stateInfo"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="item-condition">
            <el-form-item label="显示状态:" class="item-short">
              <el-select
                v-model="queryInfo.showStatus"
                placeholder="请选择状态"
                clearable
              >
                <el-option label="显示" value="1"> </el-option>
                <el-option label="不显示" value="0"> </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="item-condition">
            <el-form-item label="产业园区类型:">
              <el-select
                v-model="queryInfo.type"
                placeholder="请选择类型"
                clearable
              >
                <el-option label="国家级电商产业园区" value="1"> </el-option>
                <el-option label="省级电商产业园" value="2"> </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="item-condition">
            <el-form-item label="所属城市:" class="item-short">
              <el-select
                v-model="queryInfo.cityCode"
                placeholder="请选择城市"
                clearable
              >
                <el-option
                  v-for="item in codeListArr"
                  :key="item.code"
                  :label="item.areaName"
                  :value="item.code"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
      </div>
    </el-form>
    <el-table
      :data="industrialParkList"
      style="width: 100%"
      border
      v-loading="loading"
    >
      <el-table-column type="index" width="50" label="#" align="center">
      </el-table-column>
      <el-table-column
        label="产业园名称"
        align="center"
        width="180"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-html="showcontent(scope.row.industrialName)"></span>
        </template>
      </el-table-column>
      <!-- <el-table-column
        prop="address"
        label="地址"
        align="center"
        width="100"
        show-overflow-tooltip
      >
      </el-table-column> -->
      <el-table-column
        prop="cityCode"
        label="城市地区"
        align="center"
        width="90"
      >
        <template slot-scope="scope">
          <span>{{ codeListObj[scope.row.cityCode] }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="imageUrl"
        label="产业园图片"
        align="center"
        width="150"
      >
        <template slot-scope="scope">
          <div class="img-show">
            <el-image
              v-if="scope.row.thumb != null"
              width="75%"
              contain
              class="image-slot"
              :src="scope.row.thumb"
              :preview-src-list="[scope.row.thumb]"
              fit="contain"
            ></el-image>
            <div v-else slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column
        prop="matching"
        label="配置"
        align="center"
        width="150"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-html="showcontent(scope.row.matching)"></span>
        </template>
      </el-table-column> -->
      <!-- <el-table-column
        prop="qualification"
        label="条件"
        align="center"
        width="100"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-button @click="showDialog(scope.row.qualification)"
            >条件详情</el-button
          >
        </template>
      </el-table-column> -->
      <!-- <el-table-column label="详情展示" align="center" width="100">
        <template slot-scope="scope">
          <el-popover placement="right" width="400" trigger="click">
            
            <el-form
              label-position="left"
              inline
              class="demo-table-expand"
              label-width="100px"
            >
              <el-form-item label="产业园名称">
                <span v-html="showcontent(scope.row.industrialName)"></span>
              </el-form-item>
              <el-form-item label="面积">
                <span>{{ scope.row.areas }}</span>
              </el-form-item>
              <el-form-item label="电话">
                <span>{{ scope.row.phone }}</span>
              </el-form-item>
              <el-form-item label="地址">
                <span>{{ scope.row.address }}</span>
              </el-form-item>
              <el-form-item label="年度">
                <span>{{ scope.row.annual }}</span>
              </el-form-item>
              <el-form-item label="联系人">
                <span>{{ scope.row.concatPeople }}</span>
              </el-form-item>
              <el-form-item label="配置">
                <span v-html="showcontent(scope.row.matching)"></span>
              </el-form-item>
            </el-form> -->

      <!-- <el-link class="overflow" :underline="false" slot="reference"> -->
      <!-- <el-button slot="reference">详情展示</el-button> -->
      <!-- </el-link> -->
      <!-- </el-popover>
        </template>
      </el-table-column> -->
      <!-- <el-table-column
        prop="annual"
        label="年度"
        align="center"
        width="100"
        show-overflow-tooltip
      >
      </el-table-column> -->
      <el-table-column label="产业园类型" align="center" width="150">
        <template slot-scope="scope">
          <el-tag type="primary" size="small">
            {{
              scope.row.type === "1" ? "国家级电商产业园区" : "省级电商产业园区"
            }}
          </el-tag>
        </template>
      </el-table-column>
      <!-- <el-table-column
        prop="concatPeople"
        label="联系人"
        align="center"
        width="70"
        show-overflow-tooltip
      >
      </el-table-column> -->
      <!-- <el-table-column
        prop="phone"
        label="电话"
        align="center"
        width="120"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="areas"
        label="面积"
        align="center"
        width="130"
        show-overflow-tooltip
      >
      </el-table-column> -->
      <!-- <el-table-column
        prop="updateTime"
        label="更新时间"
        align="center"
        width="150"
        show-overflow-tooltip
      >
      </el-table-column> -->
      <el-table-column label="服务" align="center" width="120">
        <template slot-scope="scope">
          <el-popover placement="right" width="400" trigger="click">
            <span v-html="showcontent(scope.row.service)"></span>
            <el-button slot="reference">服务详情</el-button>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column label="优势" align="center" width="120">
        <template slot-scope="scope">
          <el-popover placement="right" width="400" trigger="click">
            <span v-html="showcontent(showcontent(scope.row.advantage))"></span>
            <el-button slot="reference">优势详情</el-button>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="sort" label="排序" align="center" width="70">
        <template slot-scope="scope">
          <el-input
            class="e-input"
            v-model.number="scope.row.sort"
            @blur="updateSort(scope.row)"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column label="审核状态" align="center" width="100">
        <template slot-scope="scope">
          <el-button
            plain
            size="small"
            class="padding-style"
            :type="checkStyle(scope.row.checkStatus.toString())"
            @click="examineStatus(scope.row.id)"
            disable-transitions
          >
            {{ checkShow(scope.row.checkStatus.toString()) }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop="showStatus"
        label="显示状态"
        align="center"
        width="80"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            plain
            class="padding-style"
            :type="scope.row.showStatus === '0' ? 'danger' : 'success'"
            @click="changeShow(scope.row)"
            disable-transitions
          >
            {{ scope.row.showStatus === "0" ? "不显示" : "显示" }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150" align="center">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="mini"
            @click="addOrUpdateHandle(scope.row.id)"
          >
            修改
          </el-button>
          <el-button
            type="text"
            size="mini"
            @click="deleteIndustry(scope.row.id)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 产业园区列表分页器 -->
    <el-pagination
      background
      layout="total,prev, pager, next"
      :total="totalList"
      @current-change="pageChange"
      :page-size="queryInfo.limit"
      :current-page="queryInfo.page"
    >
    </el-pagination>
    <!-- 审核新添加列表的弹框 -->
    <check-status
      :check-query="checkQuery"
      ref="checkRef"
      @updateComputed="getIndustrialParkList()"
    />
    <!-- 新增或修改产业园弹窗 -->
    <add-or-update
      v-if="addOrUpdateVisible"
      ref="addOrUpdate"
      @optionSuccess="getIndustrialParkList"
    ></add-or-update>
    <!-- 条件内容 -->
    <el-dialog title="条件内容" :visible.sync="dialogVisible" width="50%">
      <span v-html="showcontent(ifContent)"></span>
    </el-dialog>
  </div>
</template>

<script>
import { checkMixin } from "@/utils/mixin.js";
import { showcontent } from "@/utils/method.js";
import CheckStatus from "@/views/modules/config/child-components/check-status";
import getCityCode from "@/utils/cityCode.js";
import AddOrUpdate from "@/views/modules/config/child-components/industry-add-or-update";
export default {
  mixins: [checkMixin],
  components: {
    CheckStatus,
    AddOrUpdate,
  },
  data() {
    return {
      // 获取产业园区列表参数
      queryInfo: {
        page: 1,
        limit: 10,
        checkStatus: "",
        cityCode: "",
        industrialName: "",
        showStatus: "",
        type: "",
      },
      // 获取产业园区列表
      industrialParkList: [],
      // 列表总数
      totalList: 0,
      // 审核状态参数
      checkQuery: {
        id: null,
        checkStatus: "1",
      },
      // 城市编码对象列表
      codeListObj: [],
      // 城市编码数组列表
      codeListArr: [],
      // 审核状态信息
      stateInfo: [
        { name: "待审核", id: "0" },
        { name: "审核通过", id: "1" },
        { name: "审核不通过", id: "2" },
      ],
      addOrUpdateVisible: false,
      loading: false,
      dialogVisible: false,
      ifContent: "", //条件内容详情
    };
  },
  created() {
    this.getIndustrialParkList();
    getCityCode().then((data) => {
      this.codeListObj = data[0];
      this.codeListArr = data[1];
    });
  },
  methods: {
    chongzhi() {
      this.queryInfo = {
        industrialName: "",
        annual: "",
        checkStatus: "",
        cityCode: "",
        type: "",
        showStatus: "",
        page: 1,
        limit: 8,
      };
      this.$nextTick(() => {
        this.getIndustrialParkList();
      });
    },
    showcontent,
    // 获取产业园区列表
    getIndustrialParkList(id) {
      id == 1 ? (this.queryInfo.page = 1) : "";
      this.loading = true;
      this.$ajaxPost("/industrialPark/list", this.queryInfo).then(
        ({ data }) => {
          console.log("data", data);
          if (data.code === 0) {
            this.loading = false;
            this.industrialParkList = data.data.list;
            this.totalList = data.data.totalCount;
          }
        }
      );
    },
    // 分页器页数改变触发事件
    pageChange(val) {
      this.queryInfo.page = val;
      this.getIndustrialParkList();
    },
    // 打开审核新添加的产业园弹框事件
    examineStatus(id) {
      this.checkQuery.id = id;
      this.$nextTick(() => {
        this.$refs.checkRef.init("/industrialPark/update");
      });
    },
    //打开条件详情对话框
    showDialog(content) {
      console.log("12345", content);
      this.ifContent = content;
      this.dialogVisible = true;
    },
    // 更新显示状态
    async changeShow(item) {
      let { id, showStatus } = item;
      showStatus = showStatus === "1" ? "0" : "1";
      const { data } = await this.updateIndustry({ id, showStatus });
      if (data.code === 0) {
        showStatus = item.showStatus;
      }
    },
    // 更新产业园封装函数
    updateIndustry(queryInfo) {
      return this.$ajaxPost("/industrialPark/update", queryInfo);
    },
    // 更新排序保存
    updateSort(item) {
      const { id, sort } = item;
      this.$ajaxPost("/industrialPark/update", {
        id: parseInt(id),
        sort,
      }).then(({ data }) => {
        if (data.code === 0) {
          this.$message.success("排序更新成功");
          this.getIndustrialParkList();
        }
      });
    },
    // 新增或修改产业园
    addOrUpdateHandle(id) {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id);
      });
    },
    // 删除单个产业园
    deleteIndustry(id) {
      this.$confirm("此操作将永久删除该条目,是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$ajaxGet("/industrialPark/delete", { id }).then(({ data }) => {
            if (data.code === 0) {
              this.getIndustrialParkList();
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
};
</script>
<style lang="css">
.el-tooltip__popper {
  max-width: 50%;
  font-size: 14px;
}
</style>
<style lang="less" scoped>
.e-input {
  /deep/.el-input__inner {
    text-align: center;
  }
}
.search-form {
  .top-box,
  .bottom-box {
    display: flex;
    .item-condition {
      margin-left: 5px;
    }
  }
}
/deep/ .item-short {
  .el-input__inner {
    width: 110px;
  }
}
.img-show {
  display: flex;
  height: 40px;
  width: 100%;
  align-items: center;
  justify-content: center;
}
/deep/.el-icon-circle-close {
  color: white;
}
</style>